export const ACTIONS = {
  CANCEL_EDIT: 'cancelEdit',
  // NOTE: proyectType Fix (must be fixed on the backend)
  FIX_PROJECT_TYPE: 'fixProjectType',
  RESET_ADDRESS: 'resetAddress',
  SET_ADDRESS: 'setAddress',
  SET_ADDRESS_INPUT_MODE: 'setAddressInputMode',
  SET_AUTOCOMPLETED_ADDRESS: 'setAutocompletedAddress',
  SET_CURRENCY: 'setCurrency',
  SET_END_DATE: 'setEndDate',
  SET_IS_EDITING: 'setIsEditing',
  SET_IS_SAVING: 'setIsSaving',
  SET_JOB_NUMBER: 'setJobNumber',
  SET_MAPBOX_TOKEN_ACTIVE: 'setMapboxTokenActive',
  SET_MISSING_REQUIRED_FIELD: 'setMissingRequiredField',
  SET_PROJECT_DATA_CHANGED: 'setProjectDataChanged',
  SET_PROJECT_NAME: 'setProjectName',
  SET_PROJECT_TYPE: 'setProjectType',
  SET_PROJECT_VALUE: 'setProjectValue',
  SET_SHOW_DUPLICATE_NAME_ERROR: 'setDuplicateNameError',
  SET_SHOW_MODAL_CONFIRMATION: 'setShowModalConfirmation',
  SET_SHOW_PROJECT_VALUE_ERROR: 'setShowProjectValueError',
  SET_START_DATE: 'setStartDate',
  SET_STATE: 'setState',
  SET_TIMEZONE: 'setTimezone',
  SET_SOURCE_TEMPLATE: 'setSourceTemplate',
};

export const cancelEdit = () => ({ type: ACTIONS.CANCEL_EDIT });

// NOTE: proyectType Fix (must be fixed on the backend)
export const fixProjectType = (payload) => ({
  type: ACTIONS.FIX_PROJECT_TYPE,
  payload,
});

export const resetAddress = () => ({ type: ACTIONS.RESET_ADDRESS });

export const setAddress = (payload) => ({ type: ACTIONS.SET_ADDRESS, payload });

// TODO: Move to Autocomplete Address component
export const setAddressInputMode = (payload) => ({
  type: ACTIONS.SET_ADDRESS_INPUT_MODE,
  payload,
});

export const setAutocompletedAddress = (payload) => ({
  type: ACTIONS.SET_AUTOCOMPLETED_ADDRESS,
  payload,
});

export const setCurrency = (payload) => ({
  type: ACTIONS.SET_CURRENCY,
  payload,
});

export const setEndDate = (payload) => ({
  type: ACTIONS.SET_END_DATE,
  payload,
});

export const setIsEditing = (payload) => ({
  type: ACTIONS.SET_IS_EDITING,
  payload,
});

export const setIsSaving = (payload) => ({
  type: ACTIONS.SET_IS_SAVING,
  payload,
});

export const setJobNumber = (payload) => ({
  type: ACTIONS.SET_JOB_NUMBER,
  payload,
});

// TODO: Move to Autocomplete Address component
export const setIsMapboxTokenActive = (payload) => ({
  type: ACTIONS.SET_MAPBOX_TOKEN_ACTIVE,
  payload,
});

export const setMissingRequiredField = (payload) => ({
  type: ACTIONS.SET_MISSING_REQUIRED_FIELD,
  payload,
});

export const setProjectDataChanged = (payload) => ({
  type: ACTIONS.SET_PROJECT_DATA_CHANGED,
  payload,
});

export const setProjectName = (payload) => ({
  type: ACTIONS.SET_PROJECT_NAME,
  payload,
});

export const setProjectType = (payload) => ({
  type: ACTIONS.SET_PROJECT_TYPE,
  payload,
});

export const setProjectValue = (payload) => ({
  type: ACTIONS.SET_PROJECT_VALUE,
  payload,
});

export const setShowDuplicateNameError = (payload) => ({
  type: ACTIONS.SET_SHOW_DUPLICATE_NAME_ERROR,
  payload,
});

export const setShowModalConfirmation = (payload) => ({
  type: ACTIONS.SET_SHOW_MODAL_CONFIRMATION,
  payload,
});

export const setShowProjectValueError = (payload) => ({
  type: ACTIONS.SET_SHOW_PROJECT_VALUE_ERROR,
  payload,
});

export const setStartDate = (payload) => ({
  type: ACTIONS.SET_START_DATE,
  payload,
});

export const setState = (payload) => ({ type: ACTIONS.SET_STATE, payload });

export const setTimezone = (payload) => ({
  type: ACTIONS.SET_TIMEZONE,
  payload,
});

export const setSourceTemplate = (payload) => ({
  type: ACTIONS.SET_SOURCE_TEMPLATE,
  payload,
});
